import React from 'react';
import EachRec from './EachRec';

function EventDetails({
  fourItemCont,
  eventType,
  eventCapacity,
  totalBox,
  publicEvent,
  participantPerBox,
  seatPrice,
  boxPrice,
  allowUsersToReserveBox,
  pageFrom,
  hostFirstName,
  hostLastName,
  assignSeats,
  assignBoxes,
}) {
  const showHostDetails = () => {
    return (
      <>
        <EachRec head={'Event Type'} body={eventType} />
        <EachRec head={'Maximum Capacity'} body={eventCapacity} />
        <EachRec head={'No. Of Boxes'} body={totalBox} />
        <EachRec
          head={'Public Event'}
          body={publicEvent === 'Y' ? 'Yes' : 'No'}
        />
        <EachRec head={'Seats Per Box'} body={participantPerBox} />
        <EachRec head={'Seat Price'} body={'$ ' + seatPrice} />
        <EachRec head={'Box Price'} body={'$ ' + boxPrice} />
        <EachRec
          head={'Allow Users to Reserve Box'}
          body={allowUsersToReserveBox === 'Y' ? 'Yes' : 'No'}
        />
      </>
    );
  };

  const showShareDetails = () => {
    return (
      <>
        <EachRec head={'Event Type'} body={eventType} />
        {!!seatPrice && <EachRec head={'Seat Price'} body={'$ ' + seatPrice} />}
        {!!boxPrice && <EachRec head={'Box Price'} body={'$ ' + boxPrice} />}
        <EachRec
          head={'Hosted By'}
          body={hostFirstName + (hostLastName ? ' ' + hostLastName : '')}
        />
      </>
    );
  };

  const parseSeatInfo = (assignSeats) => {
    const tempDefaultBox = assignSeats?.find((box) => {
      if (box.defaultSeat === 1) {
        return true;
      }
      return false;
    });
    const seatInfo = tempDefaultBox
      ? `${tempDefaultBox.seatName} (${tempDefaultBox.boxName})`
      : 'No seat';
    return seatInfo;
    // return tempDefaultBox;
  };

  const parseBoxInfo = (assignBoxes) => {
    const boxes = assignBoxes?.map((eachBox) => eachBox.boxName);
    const boxesString = boxes?.length ? boxes.join(', ') : 'No box';
    return boxesString;
  };

  const showInviteDetails = () => {
    return (
      <>
        <EachRec head={'Event Type'} body={eventType} />
        {!!seatPrice && <EachRec head={'Seat Price'} body={'$ ' + seatPrice} />}
        {!!boxPrice && <EachRec head={'Box Price'} body={'$ ' + boxPrice} />}
        <EachRec
          head={'Hosted By'}
          body={hostFirstName + (hostLastName ? ' ' + hostLastName : '')}
        />
        <EachRec head={'Owned Boxes'} body={parseBoxInfo(assignBoxes)} />
        <EachRec head={'My Seat'} body={parseSeatInfo(assignSeats)} />
      </>
    );
  };

  const renderFunc = (pageFrom) => {
    switch (pageFrom) {
      case 'host_handle':
        return showHostDetails();

      case 'share_handle':
        return showShareDetails();

      case 'invite_handle':
        return showInviteDetails();

      default:
        break;
    }
  };

  return <div className={fourItemCont}>{renderFunc(pageFrom)}</div>;
}

export default EventDetails;
